import CnErrorFeedback from "./view";
export default CnErrorFeedback;
export { CnErrorFeedback };
export * from "./const";
export * from "./type";